<template>
	<div class="campaign-feedback container">
		<span v-if="response" class="flex-col-center">{{ response }}</span>
		<form v-else @submit.prevent="submitFeedback" class="flex-col-center feedback-form">
			<slot />
			<span v-if="error" class="feedback-submit-error">{{ error }}</span>
			<textarea v-model="feedback" cols="10" rows="4" />
			<button type="submit" class="button button-primary blue feedback-form-btn">Send as Feature Request</button>
		</form>
	</div>
</template>

<script>
export default {
	props: {
		feedbackType: {
			type: String,
			default() {
				return 'templates';
			},
		},
	},
	data() {
		return {
			feedback: '',
			error: '',
			response: '',
		};
	},
	computed: {
		searchString() {
			return this.$get(`$store.state.${this.feedbackType}.search`);
		},
	},
	methods: {
		submitFeedback() {
			if (!this.feedback) {
				this.error = 'Please enter your feedback.';
				return;
			}

			const data = {
				feedback: this.feedback,
				feedbackType: this.feedbackType,
				searchString: this.searchString,
				action: 'sendFeedback',
			};

			this.$api
				.post({ url: this.$urls.app('ajax/') })
				.send(JSON.stringify(data))
				.then((response) => {
					this.response = response.body.message;
				})
				.catch((error) => {
					this.parseError(error);
				});
		},
		parseError(error) {
			this.error = error.response
				? error.response.body.message
				: 'There was an error submitting your feedback. Please try again later.';
		},
	},
};
</script>

<style lang="scss">
.campaign-feedback {
	em,
	i {
		font-style: italic;
	}

	.flex-col-center {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.feedback-form {
		textarea {
			width: 75%;
			padding: 10px;
			margin: 20px 0;

			&:focus {
				outline: none;
				border-color: #f2f4f7;
			}
		}

		.feedback-submit-error {
			color: #ff3333;
		}
	}
}
</style>
